import React from 'react';
import { useBrand } from '../../../context/BrandContext';
import BonusPlayerCard from './BonusPlayerCard';
import { backofficePlayerUrl } from './PlayerIdentity';
import PlayerHeader from './PlayerHeader';
import ResultCard from './ResultCard';
import CheckStep from './CheckStep';
import BalanceCheckDetails from './BalanceCheckDetails';
import { DepositDetails } from './PeriodDepositsDetails';
import PeriodStory from './PeriodStory';
import { formatShortUTC } from './timeline';

// DecisionSteps: how the decision was made (detailed view), in the comp flow's order: start
// point, deposits, balance.
function DecisionSteps({ check }) {
  const { balance, period, deposits } = check;
  return (
    <div className="space-y-3">
      <h2 className="pt-2 text-lg font-bold text-ink">How the decision was made</h2>
      <CheckStep
        index={1} title="Active period" status={period.status} reason={period.reason}
        subtitle={period.period ? `${formatShortUTC(period.period.period_start)} → ${formatShortUTC(period.period.period_end)} UTC` : null}
      >
        {period.period && <PeriodStory period={period.period} week={period.week} now={check.checked_at} deposits={deposits} />}
      </CheckStep>
      <CheckStep index={2} title="Deposits in the period" status={deposits.status} reason={deposits.reason}>
        <DepositDetails deposits={deposits} />
      </CheckStep>
      <CheckStep index={3} title="Balance below $20 (all accounts)" status={balance.status} reason={balance.reason}>
        <BalanceCheckDetails balance={balance} />
      </CheckStep>
    </div>
  );
}

// CheckResult: the player and the result card; the detailed view adds the full player card and
// the steps behind the decision.
export default function CheckResult({ check, detailed, ...card }) {
  const { activeBrand } = useBrand();
  const backofficeUrl = backofficePlayerUrl(activeBrand, check.player.user_id);
  return (
    <div className="space-y-4">
      {detailed
        ? <BonusPlayerCard check={check} exception={card.exception} backofficeUrl={backofficeUrl} />
        : <PlayerHeader player={check.player} backofficeUrl={backofficeUrl} />}
      {/* keyed per check run, so drafts (comment, reason) never carry over to another player */}
      <ResultCard key={`${check.player.user_id}-${check.checked_at}`} check={check} detailed={detailed} backofficeUrl={backofficeUrl} {...card} />
      {detailed && <DecisionSteps check={check} />}
    </div>
  );
}
